import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, from, mergeMap, of } from 'rxjs';
import { TokenService } from './auth-token-service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private tokenService: TokenService) {}
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const publicEndpoint =
      req.url.indexOf('/public/calendar/') != -1 || (req.url.indexOf('/competitions/') != -1 && req.method == 'GET');

    return from(this.tokenService.getIdToken()).pipe(
      catchError((error) => {
        if (!publicEndpoint) {
          throw error;
        } else {
          return of(null);
        }
      }),
      mergeMap((token) => {
        let reqModified = req;
        if (token) {
          reqModified = reqModified.clone({ headers: reqModified.headers.set('Authorization', `Bearer ${token}`) });
        }
        reqModified = reqModified.clone({ headers: reqModified.headers.set('x-api-key', `ScasDefaultPublicApiKey`) });
        return next.handle(reqModified);
      }),
    );
  }
}
